import { Box, Typography, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { useAppSelector } from '../../../app/hooks';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { selectEndpoint } from '../apiExplorerSlice';
interface Props {
  error: string | null;
}

const NoRowsOverlayAPIExplorer: React.FC<Props> = ({ error }) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const endpoint = useAppSelector(selectEndpoint);
  const noEndpointSelected = endpoint === '';

  const noDataText = useMemo(() => {
    if (error) {
      return error;
    }

    if (noEndpointSelected) {
      return t('Select an endpoint to view data');
    }

    return t('No items found');
  }, [t, noEndpointSelected, error]);

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '1rem',
      }}
    >
      <Typography
        sx={{
          color: error ? 'red' : theme.colors.canopy.content.primary,
          fontSize: '1rem',
          fontWeight: 500,
        }}
      >
        {noDataText}
      </Typography>
    </Box>
  );
};

export default NoRowsOverlayAPIExplorer;
